"use strict";
exports.isWithinInterval = isWithinInterval;
var _index = require("./toDate.js");
function isWithinInterval(date, interval) {
  const time = +(0, _index.toDate)(date);
  const [startTime, endTime] = [
    +(0, _index.toDate)(interval.start),
    +(0, _index.toDate)(interval.end)
  ].sort((a, b) => a - b);
  return time >= startTime && time <= endTime;
}
